'use es6';

/**
 * Reads `navigator.userAgent` / `navigator.platform` (legacy but universally
 * supported) into a normalized shape. In development, prefers the modern
 * `navigator.userAgentData` API on Chromium to avoid DevTools warnings about
 * the deprecated reads; that branch is dead-code-eliminated in production
 * builds to keep the bundle small.
 *
 * Returns empty/zero values when `navigator` is undefined (SSR), so every
 * derived flag safely evaluates to `false`.
 */
function readRawData() {
  var _navigator$platform, _navigator$maxTouchPo2;
  if (typeof navigator === 'undefined') {
    return {
      userAgent: '',
      platform: '',
      maxTouchPoints: 0
    };
  }
  if (process.env.NODE_ENV !== 'production') {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) {
      var _ref, _uaData$platform, _navigator$maxTouchPo;
      return {
        userAgent: uaData.brands.map(({
          brand,
          version
        }) => `${brand}/${version}`).join(' '),
        platform: (_ref = (_uaData$platform = uaData.platform) !== null && _uaData$platform !== void 0 ? _uaData$platform : navigator.platform) !== null && _ref !== void 0 ? _ref : '',
        maxTouchPoints: (_navigator$maxTouchPo = navigator.maxTouchPoints) !== null && _navigator$maxTouchPo !== void 0 ? _navigator$maxTouchPo : 0
      };
    }
  }
  return {
    userAgent: navigator.userAgent,
    platform: (_navigator$platform = navigator.platform) !== null && _navigator$platform !== void 0 ? _navigator$platform : '',
    maxTouchPoints: (_navigator$maxTouchPo2 = navigator.maxTouchPoints) !== null && _navigator$maxTouchPo2 !== void 0 ? _navigator$maxTouchPo2 : 0
  };
}
const {
  userAgent,
  platform,
  maxTouchPoints
} = readRawData();
export const lowerUserAgent = userAgent.toLowerCase();
export const lowerPlatform = platform.toLowerCase();
export { maxTouchPoints };